import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's121g-s121m01',
    templateUrl: './s121g-s121m01.component.html'
})
export class S121gS121m01Component extends Overlay {
    scrndat: any = {};
    scrntim: any = {};
    blnk1: any = {'value': 'FOR ONE OF THE FOLLOWING:'};
    blnk2: any = {'value': 'OPTIONAL DATE RANGE:'};
    blnk3: any = {'value': 'FROM              TO'};
    cntrlno: any = {'value': '_______________'};
    frmmm: any = {'value': '__'};
    blnk4: any = {'value': '\/'};
    frmdd: any = {'value': '__'};
    blnk5: any = {'value': '\/'};
    frmyy: any = {'value': '__'};
    tomm: any = {'value': '__'};
    blnk6: any = {'value': '\/'};
    todd: any = {'value': '__'};
    blnk7: any = {'value': '\/'};
    toyy: any = {'value': '__'};
    blnk8: any = {'value': 'PNR#:'};
    pnrno: any = {'value': '______'};
    blnk9: any = {'value': 'PASSENGER NAME:'};
    psgrnm: any = {'value': '___________________'};
    blnk10: any = {'value': 'FORM OF PAYMENT:'};
    fopdpd: any = {'value': '____________________'};
    blnk11: any = {'value': '(ACCOUNT NUMBER OR OTHER DEPENDENT DATA)'};
    blnk12: any = {'value': 'TRXN:'};
    fopdpd2: any = {'value': '________________________________________________________________'};
    msgln: any = {};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};
    s1dbgMessage: any = {'value': ''};
    tracker:any = 1;

    public FIELDS: string[] = ['scrndat', 'scrntim', 'blnk1', 'blnk2', 'blnk3', 'cntrlno', 'frmmm', 'blnk4', 'frmdd', 'blnk5', 'frmyy', 'tomm', 'blnk6', 'todd', 'blnk7', 'toyy', 'blnk8', 'pnrno', 'blnk9', 'psgrnm', 'blnk10', 'fopdpd', 'blnk11', 'blnk12', 'fopdpd2', 'msgln', 'prevc1'];
    public LINES: number[] = [1, 2, 4, 5, 6, 7, 10, 11, 13, 14, 16, 18, 22, 23, 24];

    ngAfterViewInit(): void {
    }
    // wooliewj
    onChange() {
        // styling change depending on the value of the msgln, used for turning lines red.
        // if (this.msgln.value) {
        //     if (this.msgln.value.trim() == "NO DATA ENTERED - PLEASE MAKE YOUR SELECTION") {
        //         for(let i of ["cntrlno", "pnrno", "psgrnm", "fopdpd", "fopdpd2"]){
        //             const input = document.querySelector(`#${i}`);
        //             (input as HTMLElement).style.color = '#db2d20';
        //             (input as HTMLElement).style.borderBottomColor = '#db2d20';
        //         }
        //     } else {
        //         // for(let i of ["cntrlno", "pnrno", "psgrnm", "fopdpd", "fopdpd2"]){
        //         //     const input = document.querySelector(`#${i}`);
        //         //     (input as HTMLElement).style.color = '#32d13f';
        //         //     (input as HTMLElement).style.borderBottomColor = '#32d13f';
        //         // }
        //     }
        // }

        // Checks the message, if it is empty there is no error code in the backend.
        const message = this.s1dbgMessage.value.trim();
        if (message !== '') {
            if (this.tracker < 5) {
                this.s1dbgMessage.value = `DB2 DATA BASE CONTENTION. RETRYING ATTEMPT: ${this.tracker}`

                // mimics the enter key on the document level. Used to resend the request to the backend.
                document.dispatchEvent( new KeyboardEvent('keydown', {
                    key: 'Enter',
                    keyCode: 13,

                  }))

                this.tracker++

            } else {
                this.s1dbgMessage.value = `DB2 DATA BASE RETRY FAILED AFTER ${this.tracker} ATTEMPTS. CODE = ${message}`
                this.tracker = 1;
            }

        }
    }

}
